import { render, staticRenderFns } from "./ShippingCustomFieldsTab.vue?vue&type=template&id=478939f2&"
import script from "./ShippingCustomFieldsTab.vue?vue&type=script&lang=js&"
export * from "./ShippingCustomFieldsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports